module.exports = __webpack_public_path__ + "img/DSC_1357.47dcbdf7.jpeg";